export default [
	'Pharmacoeconomic'
]
